import { useCallback, useEffect, useRef, useState } from "react";
import {
  Avatar,
  Box,
  Card,
  CardContent,
  CardHeader,
  Container,
  Divider,
  TableCell,
  Stack,
  Button,
  Tab,
  Tabs,
  Typography,
  Unstable_Grid2 as Grid,
  TableRow,
  Table,
  TableHead,
  TableBody,
} from "@mui/material";
import { useParams, useNavigate } from "react-router-dom";
import {
  getFirestore,
  collection,
  onSnapshot,
  query,
  where,
  doc,
  limit,
  getDoc,
  getDocs,
} from "firebase/firestore";
import { SolicitarPresenca } from "./FlowSession/SolicitarPresenca";
import { LeituraAta } from "./FlowSession/LeituraAta";
import { VotacaoAta } from "./FlowSession/VotacaoAta";
import { GrandeExpediente } from "./FlowSession/GrandeExpediente";
import { PautasVotacao } from "./FlowSession/PautasVotacao";
import { LeituraPautas } from "./FlowSession/LeituraPauta";

type RoomParams = {
  id: string;
};

type SessaoProps = {
  id: string;
  dataSessao: string;
  legislatura: string;
  periodo: string;
  sessao: string;
  statusConfigSessao: number;
  statusSessao: string;
  tipoSessao: string;
};
export function Sessao() {
  const scrollContainerRef = useRef(null);
  const bottomRef = useRef(null);

  const params = useParams<RoomParams>();
  const roomId = params.id;

  const [sessao, setSessao] = useState<SessaoProps>({} as SessaoProps);

  useEffect(() => {
    const db = getFirestore();

    const ordersRef = doc(db, "users", `belacruz@eleg`, "sessoes", `${roomId}`);

    onSnapshot(ordersRef, (docSnapshot) => {
      const data = docSnapshot.data();
      //@ts-ignore
      setSessao(data);
    });
  }, []);

  return (
    <div className="w-full h-full min-h-screen overflow-hidden bg-gray-900">
      {sessao?.statusConfigSessao != undefined &&
        ((sessao.statusConfigSessao == 1 && (
          <SolicitarPresenca sessao={sessao} />
        )) ||
          (sessao.statusConfigSessao == 2 && <LeituraAta sessao={sessao} />) ||
          (sessao.statusConfigSessao == 3 && <VotacaoAta sessao={sessao} />) ||
          (sessao.statusConfigSessao == 4 && (
            <GrandeExpediente sessao={sessao} />
          )) ||
          (sessao.statusConfigSessao == 5 && (
            <LeituraPautas sessao={sessao} />
          )) ||
          (sessao.statusConfigSessao == 6 && (
            <PautasVotacao sessao={sessao} />
          )))}
    </div>
  );
}
